/**
 * True when a test pack / assessment has subjective (non-MCQ) questions needing manual evaluation.
 */
export function packRequiresManualEvaluation(questions = []) {
  if (!Array.isArray(questions) || questions.length === 0) {
    return false;
  }
  return questions.some((q) => {
    const t = String(q?.type || '').toUpperCase();
    return t.includes('DESCRIPTIVE') || t.includes('SUBJECTIVE') || t === 'SHORT ANSWER';
  });
}

/** Pending manual evaluations — zero for MCQ-only packs / assessments. */
export function getEffectivePendingEvalCount(entity) {
  if (entity?.requires_manual_eval === false) {
    return 0;
  }

  const questions = entity?.questions || [];
  if (questions.length > 0 && !packRequiresManualEvaluation(questions)) {
    return 0;
  }

  return Number(entity?.pending_eval_count) || 0;
}
